import { render, staticRenderFns } from "./CPSnackBar.vue?vue&type=template&id=556f80b7&scoped=true&"
import script from "./CPSnackBar.vue?vue&type=script&lang=ts&"
export * from "./CPSnackBar.vue?vue&type=script&lang=ts&"
import style0 from "./CPSnackBar.vue?vue&type=style&index=0&id=556f80b7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556f80b7",
  null
  
)

export default component.exports